import Log from 'forms-utils-lib/logger/Logger';
import getLegalConsentCopy from 'forms-utils-lib/api/legalConsent/getLegalConsentCopy';
import buildLegalConsent from './buildLegalConsent';
const buildLegalConsentDefaultsForLocale = ({
  oldLang,
  newLang,
  businessUnitId,
  selectedLegalConsentOption,
  subscriptionDefinitions,
  communicationConsentCheckboxes = []
}) => {
  const getOldLegalConsentCopy = getLegalConsentCopy({
    language: oldLang,
    businessUnitId
  });
  const getNewLegalConsentCopy = getLegalConsentCopy({
    language: newLang,
    businessUnitId
  });
  return Promise.all([getOldLegalConsentCopy, getNewLegalConsentCopy]).then(([oldLegalConsentCopy, newLegalConsentCopy]) => {
    const oldLegalConsent = buildLegalConsent({
      legalConsentOption: selectedLegalConsentOption,
      subscriptionDefinitions,
      legalConsentCopy: oldLegalConsentCopy,
      communicationConsentCheckboxes
    });
    const newLegalConsent = buildLegalConsent({
      legalConsentOption: selectedLegalConsentOption,
      subscriptionDefinitions,
      legalConsentCopy: newLegalConsentCopy,
      communicationConsentCheckboxes
    });
    return {
      oldLegalConsent,
      newLegalConsent
    };
  }).catch(e => {
    Log.error(`Unable to fetch and build legalConsent defaults`, e);
  });
};
export default buildLegalConsentDefaultsForLocale;